import MotionPresenceBoundaryExample from "../../../../../../packages/design-system/motion/examples/constellation/motion-presence-boundary";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHmotion_presence_boundary from "!!raw-loader!../../../../../../packages/design-system/motion/examples/constellation/motion-presence-boundary";
import * as React from 'react';
export default {
  MotionPresenceBoundaryExample,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHmotion_presence_boundary,
  React
};